import ApiHandler from "./ApiHandler";

const PivotalDate = {
  deleteOne: async (id) => await ApiHandler.i.auth().delete(`/pivotal-date/${id}`),
  findAll: async (query) => await ApiHandler.i.auth().get(`/pivotal-date?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/pivotal-date/find?${query.toString()}`),
  /**
   * TODO: реализовать и заменить на ApiRequest.report.getAttachment()
   * @param id
   * @param query
   * @returns {Promise<boolean|*|undefined>}
   * @deprecated
   */
  getAttachment: async (id, query) => await ApiHandler.i.auth().get(`/pivotal-date/${id}/attachment?${query.toString()}`),
  getOlympiad: async (id) => await ApiHandler.i.auth().get(`/pivotal-date/${id}/olympiad`),
  getOlympiadStep: async (id) => await ApiHandler.i.auth().get(`/pivotal-date/${id}/olympiad-step`),
  getOne: async (id) => await ApiHandler.i.auth().get(`/pivotal-date/${id}`),
  putOne: async (id, data, options) => await ApiHandler.i.auth().put(`/pivotal-date/${id}`, data, options),
  postParticipationProtocol: async (id, data, options) => await ApiHandler.i.auth().post(`/pivotal-date/${id}/participation-protocol`, data, options),
  postParticipantWork: async (id, data, options) => await ApiHandler.i.auth().post(`/pivotal-date/${id}/participant-work`, data, options),
};

export default PivotalDate;